import { Ticket } from "../../../../../models/Ticket";
import { isSwimmingSchool } from "../../../../../utils/TicketPassHelper";

export interface SwimmingSchoolAbsenceLimit {
  limit: number;
  remaining: number;
  chipLabel: string;
  tooltip: string;
}

const toFiniteNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Limit zgłoszeń nieobecności ze zwrotki karnetu.
 * Tylko passtype 9 i tylko gdy backend zwróci oba pola — inaczej UI limitu się nie pokazuje.
 * Przy remaining === 0 przycisk "Zgłoś nieobecność" jest wyłączany.
 */
export const getSwimmingSchoolAbsenceLimit = (ticket: Ticket): SwimmingSchoolAbsenceLimit | null => {
  if (!isSwimmingSchool(ticket.passtype)) {
    return null;
  }

  const limit = toFiniteNumber(ticket.changeTermLimit);
  const remaining = toFiniteNumber(ticket.changeTermRemaining);
  if (limit === null || remaining === null) {
    return null;
  }

  const remainingClamped = Math.max(0, remaining);

  return {
    limit,
    remaining: remainingClamped,
    chipLabel:
      remainingClamped > 0 ? "Pozostałe zgłoszenia nieobecności" : "Limit zgłoszeń nieobecności wykorzystany",
    tooltip:
      remainingClamped > 0
        ? `Możesz zgłosić nieobecność maks. ${limit} razy dla tego karnetu — pozostało: ${remainingClamped}/${limit}.`
        : `Wykorzystano limit ${limit} zgłoszeń nieobecności dla tego karnetu.`,
  };
};
